import { render, staticRenderFns } from "./SalesManagement.vue?vue&type=template&id=63059b77&scoped=true"
import script from "./SalesManagement.vue?vue&type=script&lang=js"
export * from "./SalesManagement.vue?vue&type=script&lang=js"
import style0 from "./SalesManagement.vue?vue&type=style&index=0&id=63059b77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63059b77",
  null
  
)

export default component.exports